export enum CommunicationChannel {
    Email = 'email',
    Letter = 'letter',
}
